import React, { useEffect, useState } from 'react';
import { Container, Paper, Typography, IconButton, Select, MenuItem } from '@mui/material';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import { TaskData } from './TaskData';
import { useNavigate } from 'react-router-dom'; // ★追加

interface UserData {
  id: string;
  name: string;
  email: string;
  passwordHash: string;
}

interface MarkdownData {
  id: string;
  title: string;
  content: string;
}

const TaskList: React.FC = () => {
  const [taskList, setTaskList] = useState<TaskData[]>([]);
  const [userList, setUserList] = useState<UserData[]>([]);
  const [markdownList, setMarkdownList] = useState<MarkdownData[]>([]);
  const navigate = useNavigate(); // ★追加

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = () => {
    const savedTasks = localStorage.getItem('task-list');
    const savedUsers = localStorage.getItem('user-list');
    const savedMarkdowns = localStorage.getItem('markdown-list');

    if (savedTasks) setTaskList(JSON.parse(savedTasks));
    if (savedUsers) setUserList(JSON.parse(savedUsers));
    if (savedMarkdowns) setMarkdownList(JSON.parse(savedMarkdowns));
  };

  const handleStatusChange = (id: string, newStatus: TaskData['status']) => {
    const updatedTasks = taskList.map(task =>
      task.id === id ? { ...task, status: newStatus } : task
    );
    localStorage.setItem('task-list', JSON.stringify(updatedTasks));
    setTaskList(updatedTasks);
  };

  const handleDelete = (id: string) => {
    if (!window.confirm('このタスクを削除しますか？')) return;
    const updatedTasks = taskList.filter(task => task.id !== id);
    localStorage.setItem('task-list', JSON.stringify(updatedTasks));
    setTaskList(updatedTasks);
  };

  const getUserName = (userId: string) => {
    const user = userList.find(u => u.id === userId);
    return user ? user.name : '不明';
  };

  const getMarkdownTitle = (markdownId: string) => {
    const doc = markdownList.find(m => m.id === markdownId);
    return doc ? doc.title : '不明';
  };

  const columns: GridColDef[] = [
    { field: 'markdownTitle', headerName: 'マークダウン', flex: 1 },
    { field: 'userName', headerName: 'ユーザー', flex: 1 },
    {
      field: 'status',
      headerName: 'ステータス',
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => (
        <Select
          value={params.value}
          onChange={(e) => handleStatusChange(params.row.id, e.target.value as TaskData['status'])}
          fullWidth
        >
          <MenuItem value="未着手">未着手</MenuItem>
          <MenuItem value="進行中">進行中</MenuItem>
          <MenuItem value="完了">完了</MenuItem>
        </Select>
      )
    },
    {
      field: 'actions',
      headerName: '操作',
      sortable: false,
      width: 100,
      renderCell: (params) => (
        <IconButton color="error" onClick={() => handleDelete(params.row.id)}>
          <DeleteIcon />
        </IconButton>
      )
    }
  ];

  const rows = taskList.map((task) => ({
    id: task.id,
    markdownTitle: getMarkdownTitle(task.markdownId),
    userName: getUserName(task.userId),
    status: task.status
  }));

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          タスク一覧
        </Typography>

        {taskList.length > 0 ? (
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            pageSizeOptions={[5, 10]}
            onRowClick={(params) => navigate(`/task/${params.row.id}`)} // ★ここ追加
          />
        ) : (
          <Typography variant="body1" color="text.secondary">
            登録されたタスクがありません。
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default TaskList;
